/**
 * Trap browser/OS back so it closes an overlay instead of leaving the page.
 *
 * @param {() => void} onBack — Tear down overlay DOM (history already popped on OS back).
 * @returns {() => void} dismiss — Call on explicit close (Chiudi, backdrop, success).
 */
export function trapModalHistory(onBack) {
  history.pushState({ metisModal: true }, '');

  let active = true;

  const handlePopState = () => {
    if (!active) return;
    active = false;
    window.removeEventListener('popstate', handlePopState);
    onBack();
  };

  function dismiss() {
    if (!active) return;
    if (history.state?.metisModal) {
      history.back();
      return;
    }
    active = false;
    window.removeEventListener('popstate', handlePopState);
    onBack();
  }

  /** Close trap without history.back() — use before programmatic hash navigation. */
  function cancel() {
    if (!active) return;
    active = false;
    window.removeEventListener('popstate', handlePopState);
    if (history.state?.metisModal) {
      history.replaceState(null, '');
    }
  }

  dismiss.cancel = cancel;

  window.addEventListener('popstate', handlePopState);
  return dismiss;
}
